import cn from 'classnames';

import s from './PeopleSlide.module.scss';

interface SlideProps {
  image?: string;
  link?: string;
  badge?: {
    name: string;
    position: string;
  };
  title?: string;
  description: string;
  className?: string;
}

const PeopleSlide = ({ badge, image, description, className }: SlideProps) => {
  return (
    <div className={cn(s.root, className)}>
      <div className={s.head}>
        {image && (
          <img
            src={image}
            width={384}
            height={280}
            className={s.img}
            alt="People"
          />
        )}
      </div>
      <div className={s.content}>
        <p className={s.text}>{description}</p>

        <div className={s.badge}>
          <span className={s.name}>{badge?.name}</span>
          <span
            className={s.position}
            dangerouslySetInnerHTML={{ __html: badge?.position ?? '' }}
          />
        </div>
      </div>
    </div>
  );
};

export { PeopleSlide };
